import { Injectable } from '@angular/core';
//import { Subject } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable()
export class MessageService {

    //myTitle: string;
    // Observable string sources
    private emitChangeSource = new Subject<any>();
    // Observable string streams
    changeEmitted$ = this.emitChangeSource.asObservable();
    // Service message commands
    emitChange(msg: any) {
        this.emitChangeSource.next(msg);
        //this.myData = change;
        //this.myTitle = msg;
        console.log(msg);
    }

}
